import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout'

import IndexPage from '@/views/PageIndex/Index.vue' // 首页母视图
import userCenter from '@/views/userCenter/index' // 个人中心母视图

import Cart from '@/views/cart/Index.vue' // 购物车母视图

import loginLayout from '@/views/loginLayout.vue' // 登录注册母视图

// import { component } from 'vue/types/umd'

// const error = (resolve) => {
//   import('@/components/error/error').then((module) => {
//     resolve(module)
//   })
// }
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      // name: 'layout',
      meta: { title: '商城主页' },
      component: layout,
      children: [
        {
          path: '/',
          redirect: '/indexpage/index'
        },
        {
          path: '/redirect',
          name: 'Redirect',
          component: () => import('@/views/login/redirect')
        },
        // 首页
        {
          path: '/indexpage',
          name: 'Index',
          component: IndexPage,
          redirect: '/indexpage/index',
          children: [
            {
              path: '/indexpage/index',
              name: 'IndexAll',
              component: () =>
                import('@/views/PageIndex/indexAll/newIndex.vue')
            }
            // 首页下分类查询页面
            // {
            //   path: '/indexpage/productlist',
            //   name: 'ProductList',
            //   component: () =>
            //     import('@/views/PageIndex/productList/Index.vue')
            // },
            // 秒杀专区
            // {
            //   path: '/indexpage/seckill',
            //   name: 'Seckill',
            //   component: () =>
            //     import('@/views/PageIndex/seckill/index.vue')
            // },
            // // 折扣专区
            // {
            //   path: '/indexpage/discount',
            //   name: 'Discount',
            //   component: () =>
            //     import('@/views/PageIndex/discount/index')
            // },
            // 拼团专区
            // {
            //   path: '/indexpage/combination',
            //   name: 'Combination',
            //   component: () =>
            //     import('@/views/PageIndex/combination/Index.vue')
            // },
            // 领卷中心
            // {
            //   path: '/indexpage/getcoupon',
            //   name: 'GetCoupon',
            //   component: () =>
            //     import('@/views/PageIndex/getCoupon/Index.vue')
            // }
            // 公告详情
            // {
            //   path: '/indexpage/noticedetail',
            //   name: 'NoticeDetail',
            //   component: () => import('@/views/PageIndex/noticeDetail/index')
            // }
          ]
        },
        // 商品详情
        // {
        //   path: '/productDetail',
        //   name: 'ProductDetail',
        //   component: () =>
        //     import('@/views/productDetail/index')
        // },
        // 购物车
        {
          path: '/cart',
          name: 'cart',
          meta: { title: '购物车' },
          component: Cart,
          redirect: '/cart/shoppingCart',
          children: [
            // 购物车
            {
              path: '/cart/shoppingCart',
              name: 'ShoppingCart',
              meta: { title: '购物车' },
              component: () =>
                import('@/views/cart/shoppingCart/index.vue')
            },
            // 核对订单
            {
              path: '/cart/settlement',
              name: 'Settlement',
              meta: { title: '核对订单' },
              component: () =>
                import('@/views/cart/settlement/newIndex.vue')
            },
            // 支付
            {
              path: '/cart/payment',
              name: 'Payment',
              meta: { title: '支付' },
              component: () =>
                import('@/views/cart/payment/newIndex')
            }
          ]
        },
        // 个人中心
        {
          path: '/userCenter',
          name: 'UserCenter',
          component: userCenter,
          redirect: '/userCenter/userInfo',
          children: [
            // 个人信息
            {
              path: '/userCenter/userInfo',
              name: 'UserInfo',
              component: () =>
                import('@/views/userCenter/userInfo/index')
            },
            // 我的订单
            {
              path: '/userCenter/myOrder',
              name: 'MyOrder',
              component: () =>
                import('@/views/userCenter/myOrder/newIndex')
            },
            // 订单详情
            {
              // 考虑一下组件复用
              path: '/userCenter/orderDetail',
              name: 'OrderDetail',
              component: () =>
                import('@/views/userCenter/Detail/newIndex') // ,
              // beforeEnter: (to, from, next) => {
              //   if (to.fullPath === '/personal/detail' || to.query.id.length <= 0) {
              //     next({ path: '/' })
              //   }
              //   next()
              // }
            },
            // 资产分配
            {
              path: '/userCenter/assetAllocation',
              name: 'AssetAllocation',
              component: () =>
                import('@/views/userCenter/assetAllocation/index')
            }
            // 地址管理
            // {
            //   path: '/userCenter/address',
            //   name: 'Address',
            //   component: () =>
            //     import('@/views/userCenter/address/index')
            // },
            // 我的足迹
            // {
            //   path: '/userCenter/footprint',
            //   name: 'Footprint',
            //   component: () =>
            //     import('@/views/userCenter/footprint/index')
            // },
            // 我的收藏
            // {
            //   path: '/userCenter/favorites',
            //   name: 'Favorites',
            //   component: () =>
            //     import('@/views/userCenter/favorites/index')
            // },
            // 优惠卷
            // {
            //   path: '/userCenter/coupon',
            //   name: 'Coupon',
            //   component: () =>
            //     import('@/views/userCenter/coupon/index')
            // },
            // 评价
            // {
            //   path: '/userCenter/myEvaluate',
            //   name: 'MyEvaluate',
            //   component: () =>
            //     import('@/views/userCenter/myEvaluate/index')
            // },
            // 提交评价
            // {
            //   path: '/userCenter/evaluate',
            //   name: 'Evaluate',
            //   component: () =>
            //     import('@/views/userCenter/myEvaluate/evaluate/index')
            // },
            // 售后
            // {
            //   path: '/userCenter/afterSales',
            //   name: 'AfterSales',
            //   component: () =>
            //     import('@/views/userCenter/aftersales/Index'),
            //   children: [
            //     // 申请售后
            //     {
            //       path: '/userCenter/afterSale/submitAS',
            //       name: 'submitAS',
            //       component: () =>
            //         import('@/views/userCenter/aftersales/views/submitAfterSales')
            //     },
            //     // 售后记录
            //     {
            //       path: '/userCenter/afterSale/asRecord',
            //       name: 'ASRecord',
            //       component: () =>
            //         import('@/views/userCenter/aftersales/views/record')
            //     },
            //     // 售后详情
            //     {
            //       path: '/userCenter/afterSale/asRecordDetail',
            //       name: 'ASRecordDetail',
            //       component: () =>
            //         import('@/views/userCenter/aftersales/views/recordDetail')
            //     }
            //   ]
            // }
          ]
        },
        // 登录，注册
        {
          path: '/self',
          name: 'Self',
          meta: { title: '登录' },
          component: loginLayout,
          redirect: '/self/login',
          children: [
            // 登录
            {
              path: '/self/login',
              name: 'Login',
              meta: { title: '登录' },
              component: () =>
                import('@/views/login/login.vue')
            },
            // 注册
            {
              path: '/self/register',
              name: 'Register',
              meta: { title: '注册' },
              component: () =>
                import('@/views/login/register.vue')
            },
            // 重置密码
            {
              path: '/self/resetPwd',
              name: 'ResetPwd',
              meta: { title: '重置密码' },
              component: () =>
                import('@/views/login/resetPwd.vue')
            }
          ]
        },
        // 声明
        {
          path: '/agreement',
          name: 'Agreement',
          meta: { notNecker: true },
          component: loginLayout,
          redirect: '/agreement/privacy',
          children: [
            // 隐私声明
            {
              path: '/agreement/privacy',
              name: 'Privacy',
              meta: { title: '隐私声明' },
              component: () =>
                import('@/views/agreement/privacy.vue')
            },
            // 在线订购协议
            {
              path: '/agreement/trade',
              name: 'Trade',
              meta: { title: '在线订购协议' },
              component: () =>
                import('@/views/agreement/trade.vue')
            },
            // 支付服务条款协议
            {
              path: '/agreement/pay',
              name: 'Pay',
              meta: { title: '支付服务条款协议' },
              component: () =>
                import('@/views/agreement/pay.vue')
            },
            // 常见问题
            {
              path: '/agreement/commonProblem',
              name: 'CommonProblem',
              meta: { title: '常见问题' },
              component: () =>
                import('@/views/agreement/commonProblem.vue')
            }
          ]
        },
        // 软件下载
        {
          path: '/agreement/download',
          name: 'Download',
          meta: { title: '软件下载' },
          component: () =>
            import('@/views/agreement/download.vue')
        }
      ]
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   console.log('beforeEach')
//   // next('/indexpage/index')
//   next()
//   // cookie没有值就跳到登陆页
//   // let area = sessionStorage.getItem('area')
//   // if (area === null && to.name !== 'login' && to.name !== 'overview') {
//   //   // Vue.prototype.$message.error('用户未登陆')
//   //   next('/login')
//   // } else {
//   // next()
//   // }
// })

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js